<footer>
    <div class="footer-top-wrapper">
        <!-- <div class="container">
            <div class="footer-top-inner-wrap">
                <div class="fooetr_social_icon_wrap">
                    <p>
                        Connect with us on social media
                    </p>
                    <div class="footer_social_icon_wrap">
                        <ul>
                            <li>
                                <a href="#" class="social_comm_icon"><span class="scl_fb_ic"><i class="fa fa-facebook-f"></i></span></a>
                            </li>
                            <li>
                                <a href="#" class="social_comm_icon"><span class="scl_twt_ic"><i class="fa fa-twitter"></i></span></a>
                            </li>
                            <li>
                                <a href="#" class="social_comm_icon"><span class="scl_twt_ic"><img
                      src="/assets/images/youtube.svg" alt="" /></span></a>
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="fooetr_link_detail_wrap">
                    <div class="comm_footer_list_sce">
                        
                        <ul>
                            <li><a href="#">Company</a></li>
                            <li><a href="#">What is {{ClientType != ConstantClient ? 'VeriKlick':'Virtusa'}}</a></li>
                            <li><a href="#">Management/Leadership </a></li>
                            <li><a href="#">Careers</a></li>
                            <li><a href="#">Support</a></li>
                            <li><a href="#">Chat with us</a></li>
                        </ul>
                    </div>
                    <div class="comm_footer_list_sce">
                        
                        <ul>
                            <li><a href="#">Solutions</a></li>
                            <li><a href="#">Client</a></li>
                            <li><a href="#">ATS</a></li>
                            <li><a href="#">VMS</a></li>
                            <li><a href="#">MSP</a></li>
                            <li><a href="#">Supplier</a></li>
                            <li><a href="#">Job Seekers</a></li>
                        </ul>
                    </div>
                    <div class="comm_footer_list_sce">
                       
                        <ul>
                            <li><a href="#">Library</a></li>
                            <li><a href="#">Blogs</a></li>
                            <li><a href="#">Press</a></li>
                            <li><a href="#">User guide </a></li>
                        </ul>
                    </div>
                    <div class="comm_footer_list_sce">
                        
                        <ul>
                            <li><a href="#">Learn More</a></li>
                            <li><a href="#">Register</a></li>
                            <li><a href="#">Request Demo</a></li>
                            <li><a href="#">Contact Us</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
        <br />
        <br /> -->
        <div class="text-center">
            <p class="text-default">
                © {{Year}} {{CompanyName}}. All Rights Reserved
            </p>
        </div>
    </div>
</footer>
<!-- <footer class="fooetr_afterlg_section" *ngIf="IsLogin" >
    <div class="container-fluid">
        <div class="fooetr_aft_lgin_wrap">
            <div class="footer_aft_left_wrap">

                <p>© {{Year}} {{ClientType != ConstantClient ? 'Verisource':'Virtusa'}}. All Rights Reserved</p>
            </div>
            <div class="footer_aft_right_wrap">
                <ul>
                    <li><a href="#">About Us</a></li>
                    <li><a href="#">Contact Us</a></li>
                    <li><a href="#">Terms & Condtions</a></li>
                    <li><a href="#">Privacy Policy</a></li>
                </ul>
            </div>
        </div>
    </div>
</footer> -->